import $api from "../http";
import { IChangePasswordModel, IUpdateUserModel, IUser } from "../models/User";

class UserServiceClass {
  async getUserByEmail(email: string) {
    return await $api.get<IUser>(`api/users/by-email/${email}`);
  }

  async deleteUser() {
    return await $api.delete<{}>("api/users/delete-account");
  }

  async changePassword(id: string | null, model: IChangePasswordModel) {
    return await $api.put<boolean>(`api/users/change-password/${id}`, model);
  }

  async updateProfile(data: IUpdateUserModel) {
    const { id, ...all } = data;
    return await $api.put<IUser>(`api/users/update/${id}`, all);
  }

  async changeProfileImage(id: string, formData: FormData) {
    return await $api.post<{ profileImagePath: string }>(`api/users/upload-image/${id}`, formData);
  }
}

export const UserService = new UserServiceClass();
